/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  CountRequestDto,
  CountResponseDto,
  FeatureCollectionDto,
  GetGoiGroupsParams,
  GoiGroupDto,
  GoiGroupVersionDto,
  GoiRequestDto,
  SseEmitter
} from '../../model';





/**
 * @summary Return gois
 */
export const getGois = (
    goiRequestDto: GoiRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FeatureCollectionDto[]>> => {
    
    
    return axios.default.post(
      `/api/v1.1/goi`,
      goiRequestDto,options
    );
  }



export const getGetGoisMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGois>>, TError,{data: GoiRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getGois>>, TError,{data: GoiRequestDto}, TContext> => {

const mutationKey = ['getGois'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGois>>, {data: GoiRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  getGois(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetGoisMutationResult = NonNullable<Awaited<ReturnType<typeof getGois>>>
    export type GetGoisMutationBody = GoiRequestDto
    export type GetGoisMutationError = AxiosError<unknown>

    /**
 * @summary Return gois
 */
export const useGetGois = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGois>>, TError,{data: GoiRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGois>>,
        TError,
        {data: GoiRequestDto},
        TContext
      > => {

      const mutationOptions = getGetGoisMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Can be used for getting goi group count.
 * @summary Get goi group count in JSON
 */
export const countGoiGroupsExtended = (
    countRequestDto: CountRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CountResponseDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/goi/groups/count/extended`,
      countRequestDto,options
    );
  }



export const getCountGoiGroupsExtendedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countGoiGroupsExtended>>, TError,{data: CountRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof countGoiGroupsExtended>>, TError,{data: CountRequestDto}, TContext> => {

const mutationKey = ['countGoiGroupsExtended'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof countGoiGroupsExtended>>, {data: CountRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  countGoiGroupsExtended(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CountGoiGroupsExtendedMutationResult = NonNullable<Awaited<ReturnType<typeof countGoiGroupsExtended>>>
    export type CountGoiGroupsExtendedMutationBody = CountRequestDto
    export type CountGoiGroupsExtendedMutationError = AxiosError<unknown>

    /**
 * @summary Get goi group count in JSON
 */
export const useCountGoiGroupsExtended = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countGoiGroupsExtended>>, TError,{data: CountRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof countGoiGroupsExtended>>,
        TError,
        {data: CountRequestDto},
        TContext
      > => {

      const mutationOptions = getCountGoiGroupsExtendedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Return group versions
 */
export const getGoiGroupVersions = (
    goiRequestDto: GoiRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GoiGroupVersionDto[]>> => {
    
    
    return axios.default.post(
      `/api/v1.1/goi/groupVersions`,
      goiRequestDto,options
    );
  }



export const getGetGoiGroupVersionsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGoiGroupVersions>>, TError,{data: GoiRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getGoiGroupVersions>>, TError,{data: GoiRequestDto}, TContext> => {

const mutationKey = ['getGoiGroupVersions'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGoiGroupVersions>>, {data: GoiRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  getGoiGroupVersions(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetGoiGroupVersionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGoiGroupVersions>>>
    export type GetGoiGroupVersionsMutationBody = GoiRequestDto
    export type GetGoiGroupVersionsMutationError = AxiosError<unknown>

    /**
 * @summary Return group versions
 */
export const useGetGoiGroupVersions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGoiGroupVersions>>, TError,{data: GoiRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGoiGroupVersions>>,
        TError,
        {data: GoiRequestDto},
        TContext
      > => {

      const mutationOptions = getGetGoiGroupVersionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const registerListener = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SseEmitter>> => {
    
    
    return axios.default.get(
      `/api/v1.1/goi/listen`,options
    );
  }




export const getRegisterListenerQueryKey = () => {
    return [
    `/api/v1.1/goi/listen`
    ] as const;
    }

    
export const getRegisterListenerQueryOptions = <TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRegisterListenerQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof registerListener>>> = ({ signal }) => registerListener({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RegisterListenerQueryResult = NonNullable<Awaited<ReturnType<typeof registerListener>>>
export type RegisterListenerQueryError = AxiosError<unknown>


export function useRegisterListener<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerListener>>,
          TError,
          Awaited<ReturnType<typeof registerListener>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterListener<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerListener>>,
          TError,
          Awaited<ReturnType<typeof registerListener>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterListener<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRegisterListener<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRegisterListenerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRegisterListenerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRegisterListenerQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof registerListener>>> = ({ signal }) => registerListener({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RegisterListenerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof registerListener>>>
export type RegisterListenerSuspenseQueryError = AxiosError<unknown>


export function useRegisterListenerSuspense<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterListenerSuspense<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterListenerSuspense<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRegisterListenerSuspense<TData = Awaited<ReturnType<typeof registerListener>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof registerListener>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRegisterListenerSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for listing goi groups.
 * @summary Get goi groups in JSON
 */
export const getGoiGroups = (
    params: GetGoiGroupsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GoiGroupDto[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/goi/groups`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetGoiGroupsQueryKey = (params?: GetGoiGroupsParams,) => {
    return [
    `/api/v1.1/goi/groups`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetGoiGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(params: GetGoiGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoiGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoiGroups>>> = ({ signal }) => getGoiGroups(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGoiGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getGoiGroups>>>
export type GetGoiGroupsQueryError = AxiosError<unknown>


export function useGetGoiGroups<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoiGroups>>,
          TError,
          Awaited<ReturnType<typeof getGoiGroups>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoiGroups<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoiGroups>>,
          TError,
          Awaited<ReturnType<typeof getGoiGroups>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoiGroups<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get goi groups in JSON
 */

export function useGetGoiGroups<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGoiGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetGoiGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(params: GetGoiGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoiGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoiGroups>>> = ({ signal }) => getGoiGroups(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGoiGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getGoiGroups>>>
export type GetGoiGroupsSuspenseQueryError = AxiosError<unknown>


export function useGetGoiGroupsSuspense<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoiGroupsSuspense<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoiGroupsSuspense<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get goi groups in JSON
 */

export function useGetGoiGroupsSuspense<TData = Awaited<ReturnType<typeof getGoiGroups>>, TError = AxiosError<unknown>>(
 params: GetGoiGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGoiGroups>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGoiGroupsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




